module.exports = __webpack_public_path__ + "media/images/home/about_us/mes (copy)-7033bd8716873ed74a269866b368e3dd.jpg";